import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'employee-license-usage',
  standalone: true,
  imports: [CommonModule, TranslateDirective, TranslatePipe],
  template: `
    <div
      class="employee-license-usage"
      [class.employee-license-usage--full]="isFull"
    >
      <div class="employee-license-usage__labels">
        <span *ngIf="limit !== null">{{
          'EMPLOYEE_LICENSE.USAGE' | translate: { used: used, limit: limit }
        }}</span>
        <span *ngIf="limit === null">{{
          'EMPLOYEE_LICENSE.UNLIMITED_USAGE' | translate: { used: used }
        }}</span>
        <strong *ngIf="isFull && used === limit" translate>EMPLOYEE_LICENSE.LIMIT_REACHED</strong>
        <strong *ngIf="limit !== null && used > limit">{{
          'EMPLOYEE_LICENSE.OVER_LIMIT' | translate: { count: used - limit }
        }}</strong>
        <span *ngIf="limit !== null && !isFull">{{
          'EMPLOYEE_LICENSE.AVAILABLE' | translate: { count: remaining }
        }}</span>
      </div>
      <p *ngIf="isFull" class="employee-license-note" translate>EMPLOYEE_LICENSE.EXISTING_ACCESS_PRESERVED</p>
      <div
        *ngIf="limit !== null && limit > 0"
        class="employee-license-usage__track"
        role="meter"
        [attr.aria-label]="
          'EMPLOYEE_LICENSE.USAGE' | translate: { used: used, limit: limit }
        "
        aria-valuemin="0"
        [attr.aria-valuemax]="limit"
        [attr.aria-valuenow]="meterValue"
      >
        <div
          class="employee-license-usage__fill"
          [style.width.%]="percentage"
        ></div>
      </div>
    </div>
  `
})
export class EmployeeLicenseUsageComponent {
  @Input() used = 0;
  @Input() limit: number | null = null;

  get isFull(): boolean {
    return this.limit !== null && this.used >= this.limit;
  }
  get remaining(): number {
    return Math.max(0, (this.limit ?? 0) - this.used);
  }
  get meterValue(): number {
    return Math.min(this.used, this.limit ?? this.used);
  }
  get percentage(): number {
    return this.limit && this.limit > 0
      ? Math.min(100, Math.max(0, (this.used / this.limit) * 100))
      : 0;
  }
}
